import axios from "axios";
import { axiosServices } from "./axiosServices";
import { urlConstants } from "../constant";

export const authServices = { loginAuth, resetPassword, verifyMagicLink, createPassword, sendOtpAuth };
// const userObj = JSON.parse(localStorage.getItem('user'));
// const apiToken = userObj? userObj.token: '';


function loginAuth(bodyData) {
    return axiosServices.postAxios('/v1/common/auth/login', bodyData).then(
        res => {  
            return res;
    });
}

function resetPassword(bodyData) {
    return axiosServices.postAxios('/v1/common/auth/reset-password', bodyData).then(
        res => {  
            return res;
    });
}

function verifyMagicLink(bodyData) {
    return axiosServices.getAxios(`/v1/common/invite/verify-magic-link?token=${bodyData}` ).then(
        res => {  
            return res;
    });
}

function createPassword(bodyData, token) {
    return axios.post(urlConstants.BASE_URI_DEV + '/v1/common/auth/create-password', bodyData, { headers: {"Authorization" : `Bearer ${token}`} }).then(
        res => { // then print response status
            return res; 
        // return handleResponse(res);
    })
}

function sendOtpAuth(bodyData) {
    return axiosServices.postAxios('/v1/common/auth/send-otp', bodyData).then(
        res => {  
            return res;
    });
}

// function handleResponse(response) { 
//     if (response.response.status == 200) {
//         return response.response.data;
//     } else {
 
//         return response.response.data;
//     }
//     // return response.text().then(text => {
//     //     const data = text && JSON.parse(text);
//     //     if (!response.ok) {
//     //         if (response.status === 401) {
//     //             // auto logout if 401 response returned from api
//     //             // logout();
//     //             window.location.reload(true);
//     //             // location.reload(true);
//     //         }

//     //         const error = (data && data.message) || response.statusText;
//     //         return Promise.reject(error);
//     //     }

//     //     return data;
//     // });
// }